/* globals $ */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('radio', radio);

    function radio() {
        return {
            restrict: 'E',
            scope: {
                name: '@',
                model: '=',
                change: '=',
                value: '=',
                label: '@',
                text: '='
            },
            template: '' +
            '<label ng-click="model=value"><input type="radio" name="{{name}}" ng-model="model" ng-value="value"' +
            ' ng-checked="model==value" ng-click="model=value" ng-change="change"/>' +
            '<span class="texto" ng-if="label">{{label | translate}}</span>' +
            '<span class="texto" ng-if="text" ng-bind-html="text"></span></label>',

            compile: function (tElt) {
                tElt.addClass('sm-radio');
            }
        };
    }

})();
